<template>
    <SOSlotModal  
        modal-title="Pengaturan Pengambilan"
        :modal-id="id"
        :no-padding="true"
        @close="!loading && close()"
    >
        <template v-slot:modal-body>
            <div class="p-4">
                <div v-if="!hiddenOptions" class="m-b-20">
                    <SOInputSelect
                        class="p-t-2"
                        :title="'Pengaturan'"
                        :selected="selectedOptions"
                        :options="options"
                        :placeholder="'Pilih Pengaturan'"
                        @option-selected="
                            (val) => {
                                selectedOptions = val;
                            }
                        "
                    />
                </div>
                <div v-if="selectedOptions == '2'">
                    <label class="remove-margin color-6f7 font-14">
                        Pilih Konsumen 
                    </label>
                    <div class="">
                        <div class="m-d-8 rounded" id="customer-select" style="border: 1px solid #C8D0DD;">
                            <div v-if="formData.customer.length" class="p-x-12 p-t-12 name-container">
                                <span
                                    v-for="(item, index) in formData.customer"
                                    :key="index"
                                    class="border p-1 rounded"
                                    style="background: #F6F6F6"
                                >
                                    <label class="pr-2 m-0">{{ item.nama }}</label>
                                    <svg @click="deleteCustomer(item.idcustomer)" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.529247 1.02876C0.789596 0.768409 1.21171 0.768409 1.47206 1.02876L5.00065 4.55735L8.52925 1.02876C8.7896 0.768409 9.21171 0.768409 9.47206 1.02876C9.73241 1.28911 9.73241 1.71122 9.47206 1.97157L5.94346 5.50016L9.47206 9.02876C9.73241 9.28911 9.73241 9.71122 9.47206 9.97157C9.21171 10.2319 8.7896 10.2319 8.52925 9.97157L5.00065 6.44297L1.47206 9.97157C1.21171 10.2319 0.789596 10.2319 0.529247 9.97157C0.268897 9.71122 0.268897 9.28911 0.529247 9.02876L4.05784 5.50016L0.529247 1.97157C0.268897 1.71122 0.268897 1.28911 0.529247 1.02876Z" fill="#6F7287"/>
                                    </svg>
                                </span>
                            </div>
                            <SOInputSearch
                                id="cari-konsumen"
                                placeholder="Ketuk untuk mencari...."
                                value=""
                                autocomplete="off"
                                :do-searching="loadOptions"
                                :delay-time="500"
                                ref="searchInput"
                            />
                        </div>
                        <div v-if="customerOptions.length" class="list-options">
                            <p class="m-d-4 f-12 f-c-midgrey f-regular">Hasil Pencarian</p>
                            <div class="name-container">
                                <span
                                    v-for="(item, index) in customerOptions"
                                    :key="index"
                                    class="border p-1 rounded"
                                    style="background: #F6F6F6"
                                    @click="selectCustomer(item)"
                                >
                                    <label class="m-0 pr-2">{{ item.nama }}</label>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00062 0.833374C9.54374 0.833374 9.98404 1.27367 9.98404 1.81679V8.01663H16.1839C16.727 8.01663 17.1673 8.45692 17.1673 9.00005C17.1673 9.54318 16.727 9.98347 16.1839 9.98347H9.98404V16.1833C9.98404 16.7264 9.54374 17.1667 9.00062 17.1667C8.45749 17.1667 8.0172 16.7264 8.0172 16.1833V9.98347H1.81741C1.27428 9.98347 0.833984 9.54318 0.833984 9.00005C0.833984 8.45692 1.27428 8.01663 1.81741 8.01663H8.0172V1.81679C8.0172 1.27367 8.45749 0.833374 9.00062 0.833374Z" fill="white"/>
                                    </svg>

                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                    <SOButton
                        :disable="loading"
                        :loading="loading"
                        class="m-t-10"
                        text="Simpan"
                        full
                        outline
                        @action="simpan()"
                    />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import conn from "@/store/utils/connection";
import { mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "AturKonsumenModal",
    components: {
        SOSlotModal,
        SOInputSelect,
        SOIconBase,
        SOInputSearch,
        SOButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            id:"modal-konsumen",
            formData: {},
            selectedOptions: '1',
            hiddenOptions: false,
            options: [
                {
                    id: 1,
                    text: "Semua Konsumen",
                },
                {
                    id: 2,
                    text: "Hanya Konsumen Tertentu",
                }
            ],
            customerOptions: [],
            defaultOptions: [
                {
                    id: "1",
                    label: "jajang",
                },
                {
                    id: "2",
                    label: "anto 2",
                },
                {
                    id: "3",
                    label: "supri 3",
                },
                {
                    id: "4",
                    label: "robert 4",
                },
                {
                    id: "5",
                    label: "lewandowski 5",
                },
            ],
        }
    },
    methods: {
        async simpan() {
            if (this.selectedOptions == 2 && !this.formData.customer.length) {
                this.$toast.warning('Belum pilih Konsumen')
                return
            }
            this.$emit("setLoading", true)
            let data = new FormData()
            data.append("type", this.selectedOptions)
            this.formData.customer.forEach(element => {
                data.append("idcustomer[]", element.idcustomer)
            });
            let res = await this.$store.dispatch("pengaturanUmumModule/updateAmbilPelunasan", data)
            if (res.success) {
                this.$toast.success('Pengaturan pelunasan traksaksi berhasil diupdate')
            } else {
                this.$toast.error(res.msg)
            }
            this.$emit("setLoading", false)
            this.close()
        },
        deleteCustomer(id){
            this.$refs.searchInput.clearText()
            this.customerOptions = []
            console.log('delete');
            var filtered = this.formData.customer.filter(function(item) { 
                return item.idcustomer !== id;  
            });
            this.formData.customer = filtered
        },
        selectCustomer(customer) {
            this.formData.customer.push(customer)
            var filtered = this.customerOptions.filter(function(item) { 
                return item.idcustomer !== customer.idcustomer;  
            });
            this.customerOptions = filtered
        },
        async loadOptions(key) {
            if (key) {
                let params = {
                    sort_by: "abjad",
                    order_by: "ASC",
                    sort_by: "abjad",
                    limit: 20,
                    offset: 0,
                    key: key
                }
                try {
                    let res = await conn.get(this.$baseurl +'masterData/meta/list_data_konsumen_v2', params)
                    if (res.data.lengthData > 0) {
                        let filteredId = this.formData.customer.map(function(item) { 
                            return item.idcustomer;  
                        });
                        this.customerOptions = res.data.data.filter(function(item) { 
                            return filteredId.indexOf(item.idcustomer) < 0;  
                        });
                        // this.customerOptions = res.data.data
                    }
                    else {
                        this.customerOptions = []
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                this.customerOptions = []
            }
        },
        open(v, formData) {
            this.hiddenOptions = v
            this.formData = JSON.parse(JSON.stringify(formData))
            this.selectedOptions = this.formData.owner_pengaturan_umum.ambil_tanpa_lunasi
            $("#" + this.id).modal("show");
        },
        close() {
            if(this.selectedOptions == '2') this.$refs.searchInput.clearText()
            this.customerOptions = []
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        getListOulet() {
            this.options = this.listOutlet.map((item) => {
                return {
                    id: item.idoutlet,
                    text: item.nama,
                }
            });
        }
    },    
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            listOutlet: "listOutlet",
        }),
        getSelectedItem() {
            return this.filterItem.konsumen;
        },
        isSelected() {
            return function(id) {
                return this.getSelectedItem.find((item) => item.id === id);
            };
        },
    },
    mounted() {
        // this.initKonsumen()
    },
}
</script>

<style scoped>
.name-container{
    display: flex;
    flex-flow: wrap;
    gap: 8px;
    overflow: auto;
    max-height: 150px;
}
#customer-select >>> .form-group div input{
    border: none;
}
#customer-select >>> .form-group div input:focus{
    box-shadow: none;
}
</style>